import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { api } from '@/api/api-client';
import { pagesConfig } from '@/pages.config';

interface PagesConfig {
    Pages: Record<string, unknown>;
    mainPage?: string;
}

interface AppLogsApi {
    logUserInApp(pageName: string): Promise<unknown>;
}

export default function NavigationTracker(): null {
    const location = useLocation();
    const { isAuthenticated } = useAuth() as { isAuthenticated: boolean };
    const { Pages, mainPage } = pagesConfig as PagesConfig;
    const pageKeysList = Object.keys(Pages);
    const mainPageKey: string | undefined = mainPage ?? pageKeysList[0];

    useEffect(() => {
        window.parent?.postMessage(
            {
                type: 'app_changed_url',
                url: window.location.href,
            },
            '*',
        );
    }, [location]);

    useEffect(() => {
        const pathname = location.pathname;
        let pageName: string | null;

        if (pathname === '/' || pathname === '') {
            pageName = mainPageKey ?? null;
        } else {
            const segment = pathname.replace(/^\//, '').split('/')[0] ?? '';
            pageName = pageKeysList.find((key) => key.toLowerCase() === segment.toLowerCase()) ?? null;
        }

        if (isAuthenticated && pageName) {
            (api as { appLogs: AppLogsApi }).appLogs
                .logUserInApp(pageName)
                .catch(() => {
                    // Silently fail - logging shouldn't break the app
                });
        }
    }, [location, isAuthenticated, pageKeysList, mainPageKey]);

    return null;
}